//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import jsep from 'jsep';
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import { getTelemetryState } from '@/api/telemetry';
import { PromiseTracker } from '@/helpers/util';
import { CREATE_FILTER, UPDATE_FILTER } from '@/store/types/actions';
import { ACCOUNT, FILTERS } from '@/store/types/namespaces';
import FilterBuilder from '../FilterBuilder.vue';
import BaseEditor from './base';

export default {
  name: 'FilterEditor',
  components: {
    FilterBuilder,
  },
  extends: BaseEditor,
  props: {
    disableTimeFilters: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      previewLoading: false,
      previewError: false,
      model: {
        name: '',
        query: '',
        inputQuery: '',
        errorMessage: null,
        totalDevices: null,
        previewDevices: null,
      },
      promiseTracker: new PromiseTracker(),
    };
  },
  computed: {
    ...mapState(ACCOUNT, { accountId: 'id' }),
    closeText() {
      return this.editing ? 'Edit filter' : 'Create filter';
    },
    previewResults() {
      if (!this.model.totalDevices) {
        return null;
      }
      return { count: this.model.previewDevices, total: this.model.totalDevices };
    },
    isFilterValid() {
      try {
        jsep(this.model.query);
        return true;
      } catch (e) {
        return false;
      }
    },
    canSave() {
      return this.model.name !== '' && this.model.query !== '';
    },
  },
  watch: {
    drawerOpen(isOpen) {
      if (!isOpen) {
        if (this.$refs.filterBuilder) {
          this.$refs.filterBuilder.reset();
        }
      }
    },
  },
  methods: {
    ...mapActions(FILTERS, [CREATE_FILTER, UPDATE_FILTER]),
    cleanAndClose() {
      if (this.$refs.filterBuilder) {
        this.$refs.filterBuilder.reset();
      }
      this.drawerOpen = false;
      this.$emit('close');
    },
    postCreateNew() {
      this.resetState();

      if (this.$refs.filterBuilder) {
        this.$refs.filterBuilder.reset();
      }
    },
    saveChanges() {
      const saveData = {
        name: this.model.name,
        expression: this.model.query,
      };

      this.isSaving = true;
      this.errorMessage = null;

      if (!this.editing) {
        return this[CREATE_FILTER](saveData).then((filterId) => {
          this.$emit('save', filterId);
          this.closeDrawer();
        }).catch((err) => {
          this.isSaving = false;
          this.errorMessage = err;
        });
      }

      saveData.id = this.editing.id;
      return this[UPDATE_FILTER](saveData).then(() => {
        this.$emit('save', saveData.id);
        this.closeDrawer();
      }).catch((err) => {
        this.isSaving = false;
        this.errorMessage = err;
      });
    },
    handleFilterChange(newQuery) {
      this.model.query = newQuery;
      this.updatePreview();
    },
    restoreModel(editingFilter) {
      if (!editingFilter) {
        this.model.name = '';
        this.model.inputQuery = '';
        this.model.query = '';
        return;
      }

      this.model.name = editingFilter.name;
      this.model.inputQuery = editingFilter.expression;

      this.resetState();
    },
    resetState() {
      this.isLoading = false;
      this.isSaving = false;
      this.previewLoading = false;
      this.previewError = false;
    },
    updatePreview: _.debounce(function updatePreview() {
      this.previewLoading = true;
      this.previewError = false;

      if (!this.model.query) {
        this.previewLoading = false;
        return;
      }

      try {
        jsep(this.model.query);
      } catch (e) {
        this.previewError = true;
        this.previewLoading = false;
        return;
      }

      // Run a query to count the devices that match the filter
      const promise = Promise.all([
        getTelemetryState(this.accountId, { scope: this.model.query, property: '$id' }),
        getTelemetryState(this.accountId, { property: '$id' }),
      ]);
      this.promiseTracker.push(promise);

      // Run the most recent preview only
      this.promiseTracker.runMostRecent(promise).then(([scopedState, state]) => {
        this.model.totalDevices = state.data.length;
        this.model.previewDevices = scopedState.data.length;

        this.previewLoading = false;
      }).catch(() => {
        this.previewError = true;
        this.previewLoading = false;
      });
    }, 1500),
  },
};
